/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { batchRequest } from '../../api/ApiService';
import { Loader } from "react-loaders";
import Teams from '../../api/Teams';

import CopyIcon from '../../containers/assets/onboarding-copy.png';

const dummyClick = e => {
  e.preventDefault();
}

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
  text-align: left;

  .loader {
    display: inline-block;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    font-weight: 500;
    color: #ed716d;
  }

  a:active, a:visited, a:link {
    font-family: 'Mukta Vaani';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #5c91f5;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const TeamPlayers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
`;

const TeamPlayer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const TeamPlayerName = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

const TeamPlayerEmail = styled.div`
  display: block;
  width: 372px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #d5d9dd;
  border-radius: 8px;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 48px;
  color: rgba(0, 27, 59, 0.6);
  text-align: left;

  padding: 0 84px 0 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
`;

const CopyButton = styled.button`
  display: flex;
  border: 0;
  background: transparent;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  width: 64px;
  height: 48px;
  background: #5c91f5;
  border-radius: 0 8px 8px 0;
  align-items: center;
  justify-content: center;
  transition: background-color .4s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #74a1f6;
  }
`;

const CopyAll = styled.div`
  margin-top: 24px;
  text-align: right;

  a:active, a:visited, a:link {
    font-family: 'Mukta Vaani';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #5c91f5;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

class TeamsAndCompetitionsStep extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      countOfTeams: 0,
      teammates: [],
    }
  }

  componentDidMount() {
    this.props.setMode('basic');

    const currentTeam = Teams.currentTeam();
    const teamID = Number(currentTeam.id);
    const competitionID = Number(currentTeam.competition);

    batchRequest([
      `${process.env.REACT_APP_API_URL}teams/`,
      `${process.env.REACT_APP_API_URL}v2/games/teamplayers/`,
    ])
      .then(res => {
        const body1 = res[0].body;
        const teams = body1
          .filter(i => Number(i.competition) === competitionID)
          .filter(i => Number(i.id) !== teamID);
        const countOfTeams = teams.length;

        const body2 = res[1].body;
        const teammates = body2.results.map(i => ({
          fullname: `${i.user.first_name} ${i.user.last_name}`,
          email: i.user.email,
        }));

        this.setState({
          loading: false,
          countOfTeams,
          teammates,
        });
      })
      .catch(err => {});
  }

  copyToClipboard = email => {
    navigator.clipboard.writeText(email);

    this.props.showMessage();
  }

  copyAllEmails = e => {
    e.preventDefault();

    const { teammates } = this.state;

    this.copyToClipboard(teammates.map(i => i.email).join("\n"));
  }

  render() {
    const { loading, countOfTeams, teammates } = this.state;

    return loading ? (
      <Wrapper>
        <Loader type="ball-scale-ripple" active />
      </Wrapper>
    ) : (
      <Wrapper>
        <Text1>Teams &amp; Competitions</Text1>
        <Text2>Your team will compete with {countOfTeams} other teams</Text2>
        <Text3>
          It is recommended to arrange <b>a kickoff meeting</b> with your team
          before the game officially starts. You can also find your teammates' information
          on <a href="#" onClick={dummyClick}>Team Profile</a> page.
        </Text3>
        <TeamPlayers>
          {teammates.map(({ fullname, email }, index) => (
            <TeamPlayer key={index}>
              <TeamPlayerName>{fullname}</TeamPlayerName>
              <TeamPlayerEmail>
                {email}
                <CopyButton onClick={() => this.copyToClipboard(email)}>
                  <img src={CopyIcon} alt="" />
                </CopyButton>
              </TeamPlayerEmail>
            </TeamPlayer>
          ))}
        </TeamPlayers>
        <CopyAll>
          <a href="#" onClick={this.copyAllEmails}>Copy All Emails</a>
        </CopyAll>
      </Wrapper>
    );
  }

}

export default TeamsAndCompetitionsStep;



// WEBPACK FOOTER //
// ./src/components/onboarding/TeamsAndCompetitions.js